import type { Property } from './types';
import skyline from './data/skyline.json';
import oakwood from './data/oakwood.json';
import gouldin from './data/gouldin.json';
import merriewood from './data/merriewood.json';
import dwight from './data/dwight.json';
import bristol from './data/bristol.json';
import blair from './data/blair.json';
import britt from './data/britt.json';
import miranda from './data/miranda.json';
import seabrg from './data/seabrg.json';
import dolan from './data/dolan.json';
import clotilda from './data/clotilda.json';
import eucalyptus from './data/eucalyptus.json';
import rose from './data/rose.json';
import gate6half from './data/gate6half.json';
import yale from './data/yale.json';
import marin2114 from './data/marin2114.json';
import sandiego from './data/sandiego.json';
import keeler from './data/keeler.json';
import fairlawn from './data/fairlawn.json';
import vine from './data/vine.json';
import josephine from './data/josephine.json';
import mandana from './data/mandana.json';
import longridge from './data/longridge.json';
import fir from './data/fir.json';
import ironwood from './data/ironwood.json';
import oysterpond from './data/oysterpond.json';

export const ALL_PROPERTIES: Property[] = [
  skyline, oakwood, gouldin, merriewood, dwight, bristol, blair, britt, miranda, seabrg,
  dolan, clotilda, eucalyptus, rose, gate6half, yale, marin2114, sandiego, keeler, fairlawn, vine, josephine, mandana, longridge, fir, ironwood, oysterpond
] as Property[];

export const BY_ID: Record<string, Property> = Object.fromEntries(
  ALL_PROPERTIES.map((p) => [p.id, p])
);

export function formatPrice(n: number): string {
  return '$' + n.toLocaleString('en-US');
}

export function formatTimeRange(start: string, end: string): string {
  return `${formatTime(start)} – ${formatTime(end)}`;
}

export function formatTime(hhmm: string): string {
  const [h, m] = hhmm.split(':').map(Number);
  const am = h < 12;
  const h12 = h === 0 ? 12 : h > 12 ? h - 12 : h;
  return `${h12}:${m.toString().padStart(2, '0')} ${am ? 'AM' : 'PM'}`;
}
